import { FC, useEffect } from 'react';
import { CabinetContainer } from '../../../components/cabinet-container';
import { Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { IconUpload } from '../../../common/icons';
import { useAppDispatch, useAppSelector } from '../../../store';
import { WantedListTypeEnum } from '../../../features/wanted-list/enums';
import { fetchWantedListAll, fetchWantedListUpdate } from '../../../features/wanted-list/thunks';
import { useTranslation } from 'react-i18next';
import { useDialog } from '../../../common/hooks';
import {
  WantedListInternationalDialog,
  WantedListNationalDialog,
} from '../../../features/wanted-list/dialogs';

export const WantedListPage: FC = () => {
  const dispatch = useAppDispatch();
  const { result } = useAppSelector((state) => state.wantedListSlice.wantedList);
  const [openNationalDialog, closeNationalDialog] = useDialog(WantedListNationalDialog);
  const [openInternationalDialog, closeInternationalDialog] = useDialog(
    WantedListInternationalDialog,
  );
  const { t } = useTranslation();

  const nationalFiles = result?.filter((item) => item.type === WantedListTypeEnum.National);
  const internationalFiles = result?.filter(
    (item) => item.type === WantedListTypeEnum.International,
  );

  const handleClick = (type: WantedListTypeEnum) => {
    if (type === WantedListTypeEnum.National) {
      openNationalDialog({
        title: "Milliy ro'yxatlar",
        list: nationalFiles,
        handleValid: async (values: any) => {
          try {
            await dispatch(
              fetchWantedListUpdate({
                id: nationalFiles![0].id,
                type,
                files: { ...values },
                file_id: '112233445566778890',
              }),
            ).then(() => {
              closeNationalDialog();
              dispatch(fetchWantedListAll());
            });
          } catch (error) {}
        },
      });
    }
    if (type === WantedListTypeEnum.International) {
      openInternationalDialog({
        title: "Xalqaro ro'yxatlar ",
        list: internationalFiles,
        handleValid: async (values: any) => {
          await dispatch(
            fetchWantedListUpdate({
              id: internationalFiles![0]!.id,
              type,
              files: { ...values },
              file_id: '112233445566778890',
            }),
          );
          closeInternationalDialog();
          dispatch(fetchWantedListAll());
        },
      });
    }
  };

  useEffect(() => {
    dispatch(fetchWantedListAll());
  }, [dispatch]);

  return (
    <CabinetContainer>
      <Card sx={{ mb: 2 }}>
        <CardContent
          component={Stack}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography>{t('national.list')}</Typography>
          <Stack direction="row" spacing={1}>
            <Button
              startIcon={<IconUpload />}
              variant="contained"
              onClick={() => handleClick(WantedListTypeEnum.National)}
            >
              {t('action.upload')}
            </Button>
          </Stack>
        </CardContent>
      </Card>
      <Card>
        <CardContent
          component={Stack}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography>{t('international.list')}</Typography>
          <Stack direction="row" spacing={1}>
            <Button
              startIcon={<IconUpload />}
              variant="contained"
              onClick={() => handleClick(WantedListTypeEnum.International)}
            >
              {t('action.upload')}
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </CabinetContainer>
  );
};
